function checkCDV(bankAccount) {
	var isValid;
	var checkPositions = '9731';
	var sum = 0;
	for (var i = 0; i < 8; i++) {
		sum += bankAccount[i] * checkPositions[i % 4];
	}

	if (!(sum % 10)) {
		sum = 0;
		for (var j = 8; j < bankAccount.length; j++) {
			sum += bankAccount[j] * checkPositions[j % 4];
		}
	}

	if (!(sum % 10)) {
		isValid = true;
	} else {
		isValid = false;
	}
	return isValid;
}

export default checkCDV;
